var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"modal-header"},[_vm._t("close")],2),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"mb-3 row"},[_vm._t("email")],2),_c('div',{staticClass:"mb-0 row"},[_vm._t("password")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }